import React from "react";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";
import { CSSTransitionGroup } from "react-transition-group";
import { connect } from "react-redux";
import { reportLayout } from "./actions";

export const animationDuration = 1000 / 3;

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  & > .sub-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

export const Banner = styled.div``;

export const Navbar = styled.div`
  height: 50px;
  width: 100%;
  z-index: 1000;
  position: sticky;
  top: 0em;
  & a {
    display: inline-block;
  }
`;

export const Columns = styled(CSSTransitionGroup)`
  flex: 1;
  display: flex;
  flex-direction: row;
  position: relative;
  background: repeating-linear-gradient(
      165deg,
      transparent,
      transparent 4px,
      ${Colors.LIGHT_GRAY4} 4px,
      ${Colors.LIGHT_GRAY4} 7px
    ),
    linear-gradient(15deg, ${Colors.LIGHT_GRAY2}, ${Colors.LIGHT_GRAY5});
`;

export const Map = styled.div`
  height: calc(100vh - 50px);
  width: 100%;
  position: sticky;
  top: 50px;
`;

export const Main = styled.div`
  flex: 3;
  overflow: visible;
`;

export const Sidebar = styled.div`
  flex: 2;
  &.example-enter {
    transform: translateX(100%);
  }
  &.example-enter.example-enter-active {
    transform: translateX(0);
    transition: all ${animationDuration}ms ease;
  }
  &.example-leave {
    display: inline-block;
    position: absolute;
    overflow: hidden;
    right: 0;
    top: 0;
    height: 100%;
    width: 40%; /* fallback */
    width: min-content;
    min-width: 40%;
    float: right;
  }
  &.example-leave.example-leave-active {
    transform: translateX(100%);
    transition: all ${animationDuration}ms ease;
  }
`;

export const Footer = styled.div`
  min-height: 3em;
  flex: 0 0 auto;
`;

class Layout extends React.Component {
  getReport() {
    const { banner, navbar, main, sidebar, footer } = this.props;
    return {
      banner: Boolean(banner),
      navbar: Boolean(navbar),
      main: Boolean(main),
      sidebar: Boolean(sidebar),
      footer: Boolean(footer)
    };
  }

  report() {
    setTimeout(() => this.props.report(this.getReport()), 1);
  }

  render() {
    const { banner, navbar, main, sidebar, footer, layout } = this.props;
    return (
      <Wrapper>
        <div className="sub-wrapper">
          {layout.banner && <Banner>{banner}</Banner>}
          {layout.navbar && <Navbar>{navbar}</Navbar>}
          <Columns
            transitionName="example"
            transitionEnterTimeout={animationDuration}
            transitionLeaveTimeout={animationDuration}
          >
            {layout.main && <Main>{main}</Main>}
            {layout.sidebar && <Sidebar>{sidebar}</Sidebar>}
          </Columns>
        </div>
        {layout.footer && <Footer>{footer}</Footer>}
      </Wrapper>
    );
  }

  componentDidMount() {
    this.report();
  }

  componentDidUpdate() {
    this.report();
  }
}

export default connect(
  state => ({
    layout: state.layout
  }),
  dispatch => ({
    report: layout => dispatch(reportLayout(layout))
  })
)(Layout);



// WEBPACK FOOTER //
// ./src/app/layout/Layout.js